/**
 * @providesModule PrizeBoxClaimViewV2.style
 *
 */

// @ts-nocheck
import constants from 'HomeScreenConstants';
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import {StyleSheet} from 'react-native';

const {fontSecondary, fontSizeVeryLarge, fontSizeMedium, fontSizeH2} = SkillzStyle.fullStyles;

export const stylesFn = () => {
  return StyleSheet.create({
    background: {
      backgroundColor: SkillzStyle.convertToOpacity('#000000', 0.8),
    },

    emptyBackground: {
      backgroundColor: SkillzStyle.convertToOpacity('#000000', 0.8),
      justifyContent: 'center',
      alignItems: 'center',
    },

    activityIndicator: {
      marginVertical: 20,
      alignSelf: 'center',
    },

    balanceBarContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },

    balanceBar: {
      backgroundColor: 'transparent',
      height: constants.getBalanceBarHeight(),
      borderBottomColor: SkillzStyle.convertToOpacity('#FFFFFF', 0.15),
      color: '#FFFFFF',
    },

    prizeAnimContainer: {
      flexDirection: 'row',

      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
    },

    prizeAnimContainerInner: {
      padding: 15,

      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    prizeBoxClaimInnerContainer: {
      justifyContent: 'center',
      alignItems: 'center',
    },

    prizeBoxClaimContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    prizeLabel: {
      ...fontSecondary,
      ...Sizes.select({
        phone: {
          ...fontSizeMedium,
        },
        tablet: {
          ...fontSizeVeryLarge,
        },
      }),
      color: '#ffffff',
      textAlign: 'center',
      marginTop: -6,
    },

    prizeTypeContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
    },

    gradientSurfaceContainer: {
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
    },

    touchableOpacity: {
      flex: 1,
    },

    bottomText: {
      ...fontSecondary,
      ...Sizes.select({
        phone: {
          ...fontSizeH2,
        },
        tablet: {
          ...fontSizeVeryLarge,
        },
      }),
      color: '#ffffff',
      textAlign: 'center',
      bottom: 100,
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: 24,
    },
  });
};
